import { suggest_Minus_str, suggest_Check_str } from '@zenlayer/zen-design-icons';
import { useControllableValue } from 'ahooks';
import classnames from 'classnames';
import { useMemo } from 'react';
import insertRipple from '../_util/insertRipple';
import { pickDomAttrs } from '../_util/utils';
import SvgIcon from '../svg-icon';
import CheckboxGroup from './checkbox-group';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = props => {
  const {
    defaultChecked,
    checked,
    onChange,
    label,
    disabled = false,
    shape = 'square',
    size = 'm',
    indeterminate,
    labelClassName,
    block,
    children,
    className,
    style,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉

    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-checkbox");
  const [internalChecked, internalOnChange] = useControllableValue(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultChecked',
    valuePropName: 'checked',
    trigger: 'onChange'
  });
  const iconNode = useMemo(() => {
    if (indeterminate) {
      return /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: suggest_Minus_str,
        className: "".concat(baseClassName, "-inner-icon")
      });
    } else if (internalChecked) {
      return /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: suggest_Check_str,
        className: "".concat(baseClassName, "-inner-icon")
      });
    }
  }, [internalChecked, indeterminate]);
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("label", {
    ...attrs.others,
    className: classnames(className, baseClassName, {
      ["".concat(baseClassName, "-").concat(size)]: !!size,
      ["".concat(baseClassName, "-disabled")]: !!disabled,
      block
    }),
    style: style,
    children: [/*#__PURE__*/_jsxs("span", {
      ...attrs.data,
      className: classnames("".concat(baseClassName, "-inner"), {
        disabled: !!disabled,
        check: internalChecked,
        indeterminate: indeterminate,
        ["".concat(shape)]: !!shape
      }),
      onClick: e => {
        e.stopPropagation();
        !disabled && internalOnChange(!internalChecked);
      },
      ref: ref => {
        insertRipple({
          ref
        });
      },
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        className: classnames("".concat(baseClassName, "-input")),
        disabled: disabled
      }), iconNode]
    }), !!(label || children) && /*#__PURE__*/_jsx("span", {
      className: classnames(labelClassName, "".concat(baseClassName, "-inner-label")),
      children: label || children
    })]
  });
};
Checkbox.Group = CheckboxGroup;
export default Checkbox;